import React, { useState } from 'react';
import { CouponContainer, CouponInputContainer, CouponInput, CouponResultContainer, CouponResultMessage } from './CouponCode.styles.js';
import { CgButton, EButtonVariant, ECgButtonSize } from '../CgButton/CgButton.js';
import { Icons } from '@citygross/icons';
import { theme } from '@citygross/design-tokens';
import { Link, ELinkVariant } from '../Links/Link.js';
import { TextTypes } from '@citygross/typography';
var ECouponCodeStatus;

(function (ECouponCodeStatus) {
  ECouponCodeStatus["Success"] = "Success";
  ECouponCodeStatus["Invalid"] = "Invalid";
  ECouponCodeStatus["Error"] = "Error";
  ECouponCodeStatus["Empty"] = "Empty";
})(ECouponCodeStatus || (ECouponCodeStatus = {}));

var CouponResultIcon = function CouponResultIcon(_a) {
  var _b, _c, _d;

  var status = _a.status;

  switch (status) {
    case ECouponCodeStatus.Success:
      return React.createElement(Icons.CheckMark, {
        color: (_b = theme.palette) === null || _b === void 0 ? void 0 : _b.alertGreen,
        width: 20,
        height: 20
      });

    case ECouponCodeStatus.Invalid:
      return React.createElement(Icons.Cross, {
        color: (_c = theme.palette) === null || _c === void 0 ? void 0 : _c.alertRed,
        width: 20,
        height: 20
      });

    default:
      return React.createElement(Icons.Alert, {
        color: (_d = theme.palette) === null || _d === void 0 ? void 0 : _d.alertRed,
        width: 20,
        height: 20
      });
  }
};

function CouponCode(_a) {
  var label = _a.label,
      resetLabel = _a.resetLabel,
      placeholder = _a.placeholder,
      onSubmit = _a.onSubmit,
      status = _a.status,
      loading = _a.loading,
      value = _a.value,
      setValue = _a.setValue,
      onReset = _a.onReset;

  var _b = useState(false),
      customFocus = _b[0],
      setCustomFocus = _b[1];

  return React.createElement(React.Fragment, null, (status === null || status === void 0 ? void 0 : status.status) === ECouponCodeStatus.Empty ? React.createElement(CouponContainer, null, React.createElement(CouponInputContainer, null, React.createElement(CouponInput, {
    type: "text",
    placeholder: placeholder,
    value: value,
    onChange: function onChange(e) {
      return setValue(e.currentTarget.value);
    },
    onMouseDown: function onMouseDown() {
      setCustomFocus(true);
    },
    onKeyDown: function onKeyDown(event) {
      if (event.key === 'Enter') {
        onSubmit();
        event.preventDefault();
      }
    },
    onBlur: function onBlur() {
      return setCustomFocus(false);
    },
    customFocus: customFocus
  })), React.createElement("div", null, React.createElement(CgButton, {
    variant: EButtonVariant.secondary,
    disabled: loading,
    onClick: function onClick() {
      return onSubmit();
    },
    size: ECgButtonSize.medium,
    fullWidth: true,
    loading: loading
  }, label))) : React.createElement(CouponResultContainer, {
    status: status === null || status === void 0 ? void 0 : status.status
  }, (status === null || status === void 0 ? void 0 : status.status) === ECouponCodeStatus.Success ? React.createElement(CouponResultMessage, null, React.createElement(CouponResultIcon, {
    status: status === null || status === void 0 ? void 0 : status.status
  }), React.createElement("p", null, status === null || status === void 0 ? void 0 : status.message)) : React.createElement(React.Fragment, null, React.createElement(CouponResultMessage, null, React.createElement(CouponResultIcon, {
    status: status === null || status === void 0 ? void 0 : status.status
  }), React.createElement("p", null, status === null || status === void 0 ? void 0 : status.message)), React.createElement(Link, {
    asButton: true,
    variant: ELinkVariant.TERTIARY,
    size: TextTypes.TextSize.SMALL,
    onClick: function onClick() {
      return onReset();
    }
  }, resetLabel))));
}

export { CouponCode, ECouponCodeStatus };